import {
  ActionType,
  type GetOwnersPayload,
  type Owners,
  type GetOwnerByIdPayload,
  type OwnerDataResponse,
  type UpdateOwnerPayload,
  type DeleteOwnerPayload,
  type BulkDeleteOwnersPayload,
  type ArchiveOwnerPayload,
} from './types'
import { ActionCallback, IValidationCallback } from 'store/model'

export const getOwners = (payload?: GetOwnersPayload, callback?: IValidationCallback): ActionCallback<GetOwnersPayload> => ({
  type: ActionType.GET_OWNERS,
  payload: payload || {},
  callback,
})

export const setOwners = (payload: Owners | null) => ({
  type: ActionType.SET_OWNERS,
  payload,
})

export const getOwnerById = (payload: GetOwnerByIdPayload, callback?: IValidationCallback): ActionCallback<GetOwnerByIdPayload> => ({
  type: ActionType.GET_OWNER,
  payload,
  callback,
})

export const setOwner = (payload: OwnerDataResponse | null) => ({
  type: ActionType.SET_OWNER,
  payload,
})

export const updateOwner = (payload: UpdateOwnerPayload, callback?: IValidationCallback): ActionCallback<UpdateOwnerPayload> => ({
  type: ActionType.UPDATE_OWNER,
  payload,
  callback,
})

export const deleteOwner = (payload: DeleteOwnerPayload, callback?: IValidationCallback): ActionCallback<DeleteOwnerPayload> => ({
  type: ActionType.DELETE_OWNER,
  payload,
  callback,
})

export const bulkDeleteOwners = (payload: BulkDeleteOwnersPayload, callback?: IValidationCallback): ActionCallback<BulkDeleteOwnersPayload> => ({
  type: ActionType.BULK_DELETE_OWNERS,
  payload,
  callback,
})

export const archiveOwner = (payload: ArchiveOwnerPayload, callback?: IValidationCallback): ActionCallback<ArchiveOwnerPayload> => ({
  type: ActionType.ARCHIVE_OWNER,
  payload,
  callback,
})

export const unarchiveOwner = (payload: ArchiveOwnerPayload, callback?: IValidationCallback): ActionCallback<ArchiveOwnerPayload> => ({
  type: ActionType.UNARCHIVE_OWNER,
  payload,
  callback,
})
